import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'jspdf-autotable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { DADOS_ACESSO_DECLARACAO_RENDIMENTO_EMPRESTIMO_FINANCIAMENTO } from '../../../../app.constants';
import { CodigoTributacaoModel } from '../../../shared/models/codigoTributacao.model';
import { CodigoTributacaoTotalModel } from '../../../shared/models/codigoTributacaoTotal.model';
import { DeclIrSefModel } from '../../../shared/models/declIrSef.model';
import { ObterDeclIrSefModel } from '../../../shared/models/obterDeclIrSef.model';
import { PessoaJuridicaModel } from '../../../shared/models/pessoa-juridica.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { FinanceiroService } from '../../service/financeiro.service';
import { DeclIrSefParamsDTO } from './../../../shared/dominios/DTO/declIrSef-árams.DTO';
import { DeclaracaoRendEmpFinDetalhePdf } from './../../../shared/services/documentos-pdf-imprimir/financeiro/declaracao-rend-emp-fin/declaracao-rend-emp-fin-detalhe-pdf';
import { DeclaracaoRendimentoEmpFinService } from '../service/declaracao-rendimento-emp-fin.service';
import { ToastrService } from 'ngx-toastr';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';

@Component({
  selector: 'app-declaracao-rend-emp-fin-detalhe',
  templateUrl: './declaracao-rend-emp-fin-detalhe.component.html',
  styleUrls: ['./declaracao-rend-emp-fin-detalhe.component.css']
})
export class DeclaracaoRendEmpFinDetalheComponent implements OnInit {


  @BlockUI() blockUi: NgBlockUI;

  param: string;

  componentes: any[] = [1];

  codigoTributacaoTotalModel: Array<CodigoTributacaoTotalModel> = new Array<CodigoTributacaoTotalModel>();
  codigoTributacaoModel: Array<CodigoTributacaoModel> = new Array<CodigoTributacaoModel>();

  cdCentrus: number;
  versaoRetorno: number;

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  caminhoDeclaracao: string;

  declIrSefParamsDTO: DeclIrSefParamsDTO = new DeclIrSefParamsDTO();

  declIrSef: DeclIrSefModel = new DeclIrSefModel();

  cpf: any;
  titlePage: string;
  anoDeclardo: number;

  pessoaJuridicaModel: PessoaJuridicaModel = new PessoaJuridicaModel();

  constructor(
    private declaracaoRendimentoEmpFinService: DeclaracaoRendimentoEmpFinService,
    private financeiroService: FinanceiroService,
    private activatedRoute: ActivatedRoute,
    private authInterceptor: AuthInterceptor,
    private toastrService: ToastrService,
    private router: Router,
    private declaracaoRendEmpFinDetalhePdf: DeclaracaoRendEmpFinDetalhePdf,
    private pessoaService: PessoaService
  ) {

  }




  ngOnInit() {
    // this.param = '/financeiros/declaracaoRedimentosEmpFin/' + this.caminhoDeclaracao;
    this._gerenciarCodigoIndentificao();

  }


  getDadosSesseionStorage(): Promise<string> {
    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(DADOS_ACESSO_DECLARACAO_RENDIMENTO_EMPRESTIMO_FINANCIAMENTO);
      resolve(recuperandoObjeto);
    })


  }


  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
    .then(recuperandoObjeto => {

      if (recuperandoObjeto) {
        const novoObjeto = JSON.parse(recuperandoObjeto);
        this.declIrSefParamsDTO = new DeclIrSefParamsDTO(Number(novoObjeto[`cdCentrus`]), Number(novoObjeto[`tpEmpFin`]), Number(novoObjeto[`nrContrato`]), Number(novoObjeto[`dtLancto`]))
        this.cdCentrus = this.declIrSefParamsDTO.cdCentrus;
      } else {
        this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
      }
      this.getPessoasDadosSimplificado();
      this.getPessoaJuridica();
      this._verificarTipoDeclaracaoRebdimento();
    })
  }




  private _verificarTipoDeclaracaoRebdimento(): void {
    const tipoRecebido = this.activatedRoute.snapshot.params.tipo;
    (tipoRecebido === 'emp') ? this.obterContratos('EMPRÉSTIMO PESSOAL') : this.obterContratos('FINANCIAMENTO');
    this.param = '/financeiros/declaracaoRedimentosEmpFin/' + tipoRecebido;
  }

  async getPessoasDadosSimplificado() {
    try {

      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getObterDeclIrSef();
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getDeclRendDirfBeanObterDeclDirf() {
    try {
      this.codigoTributacaoModel = await this.financeiroService.getDeclRendDirfBeanObterDeclDirf(this.cdCentrus, this.versaoRetorno);
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getObterDeclDirfSoma() {
    try {
      this.codigoTributacaoTotalModel = await this.financeiroService.getObterDeclDirfSoma(this.cdCentrus, this.versaoRetorno);
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.error(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }



  async obterContratos(titlePage) {
    try {
      this.titlePage = titlePage;
      this.getPessoasDadosSimplificado();
      this.anoDeclardo = await this.declaracaoRendimentoEmpFinService.getUltimaDataReferenciaISW(this.cdCentrus);
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }



  async getObterDeclIrSef() {
    try {
      this.declIrSef = await this.declaracaoRendimentoEmpFinService.
        getObterDeclIrSef(
          this.declIrSefParamsDTO.cdCentrus,
          this.declIrSefParamsDTO.tpEmpFin,
          this.declIrSefParamsDTO.nrContrato,
          this.declIrSefParamsDTO.dtLancto
        )

      const obterDeclIrSefDTO = this._ordernaListaPorMes(this.declIrSef.obterDeclIrSefDTO);
      this.declIrSef.obterDeclIrSefDTO = obterDeclIrSefDTO.filter((item: ObterDeclIrSefModel) => item.mmTab !== 0)
    } catch (error) {
      this.router.navigate([this.param], { skipLocationChange: true })
      this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  private _ordernaListaPorMes(items) {
    return items.sort(function (a, b) {
      if (a.mmTab > b.mmTab) {
        return 1;
      }
      if (a.mmTab < b.mmTab) {
        return -1;
      }
      return 0;
    });
  }


  async getPessoaJuridica() {
    try {
      this.pessoaJuridicaModel = await this.pessoaService.getPessoaJuridica();
    } catch (error) {
      console.error(error);
    }
  }




  imprimirPagina() {
    this.declaracaoRendEmpFinDetalhePdf.funcionarios(this.anoDeclardo, this.titlePage, this.pessoaJuridicaModel,
      this.pessoaDadosSimplicadosModel, this.declIrSef);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/declaracao-rendimento-emp-fin/declaracao-rend-emp-fin-detalhe/declaracao-rend-emp-fin-detalhe.component.ts